import { render } from "./printTable.vue?vue&type=template&id=51ed4ffd&scoped=true"
import script from "./printTable.vue?vue&type=script&lang=js"
export * from "./printTable.vue?vue&type=script&lang=js"

import "./printTable.vue?vue&type=style&index=0&id=51ed4ffd&lang=less&scoped=true"

import exportComponent from "D:\\work\\ask_cloud\\QC\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51ed4ffd"]])

export default __exports__